<template>
    <div class="footer-menu d-flex  ">
        <div class="footer-menu-item" :class="{ active: activeTab === 'home', inactive: activeTab !== 'home' }" @click="changeTab('')">
            <div><span class="pi pi-home me-2"></span>HOME</div>
        </div>
        <div class="line"></div>
        <div class="footer-menu-item" :class="{ active: activeTab === 'user', inactive: activeTab !== 'user' }" @click="changeTab('user')">
            <div><span class="pi pi-user me-2"></span>user</div>
        </div>
    </div>
</template>

<script>
import "primeicons/primeicons.css";

export default {
    props: {
        activeTab: {
            type: String,
            required: true
        }
    },
    methods: {
        changeTab(tab) {
            // console.log('object',tab);
            this.$emit('menu-click', tab);
        }
    }
}
</script>

<style scoped>
.footer-menu{
    border-top : 1px solid #5e5e5e33;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background-color: #fff;
    box-shadow: #00000033 0px 7px 29px 0px;
    padding: 0;
}
.icon{
    width: 20px;
    height: 20px;
    margin-right: 10px;
}
.active{
    color: #06b472 !important;
    font-weight: bold !important;
    background-color: #e4fff5;
}
.footer-menu-item{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
}
.inactive{
    color: #000 !important;
}
.line{
    border-left: 1px solid #5e5e5e33;
    height: 100%;
}
</style>